module.exports = __webpack_public_path__ + "static/media/genwest-medium-banner-image-1x.b9b766bc.jpg";